<template>
  <InfoBranch
    v-if="item.config && (item.config['campaign-oid'] || item.config['campaignOid'])"
    :content="item.meta.name"
    :style="{
      marginTop: '2px',
    }"
  />
</template>
<script>
import InfoBranch from '../utils/InfoBranch'
export default {
  name: 'RegistersForCampaign',
  components: {
    InfoBranch
  },
  props: {
    item: {
      type: Object,
      default: null
    }
  }
}
</script>